import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';
import { EquipmentFilter } from '../models/equipment-filter.model';
import { PageInfo } from '../models/dynamic-filter.model';
import { DynamicStats } from '../models/entity-model-customization.model';
import { EmcSearchOutput } from '../models/emc-search.model';
import { EditCimEquipment } from '../models/cim-equipment.model';
import { ResponsePackage } from '../models/util.model';
import { SchematicValidationDataIn, SchematicValidationIssue } from '../models/schematic.model';

@Injectable({
  providedIn: 'root',
})
export class EquipmentListService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig,
  ) {
    this.pathApi = this.config.pathApi + 'cim/Equipment/';
  }

  getAllDynamic(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAllDynamic`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getStatsDynamic(obj: DynamicStats): Observable<any> {
    return this.http.post(`${this.pathApi}getStatsDynamic`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  getV3EquipmentStats(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getV3EquipmentStats`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }

  downloadDynamic(originalFilter: EquipmentFilter): Observable<any> {
    const filterCopy: any = {
      pageInfo: new PageInfo(-1, -1),
      filterParams: {
        ...originalFilter.filterParams,
        selectedAreas:
          originalFilter.filterParams.selectedAreaModels?.map((a: any) => a.id) || [],
        selectedUsers:
          originalFilter.filterParams.selectedUserModels?.map((u: any) => u.id) || [],
        selectedTransmissionStations:
          originalFilter.filterParams.selectedTsModels?.map((ts: any) => ts.id) || [],
      },
      dynamicFilters: originalFilter.dynamicFilters.map((df: any) => ({ ...df })),
      searchObject: { ...originalFilter.searchObject },
      utilityId: originalFilter.utilityId,
      cimClass: originalFilter.cimClass,
    };

    return this.http.post(`${this.pathApi}downloadFileDynamic`, filterCopy);
  }

  getByGuid(dataIn: any): Observable<HttpResponse<ResponsePackage<EditCimEquipment>>> {
    return this.http.post<ResponsePackage<EditCimEquipment>>(
      `${this.pathApi}getByGuid`,
      dataIn,
      {
        headers: this.headers,
        observe: 'response',
      }
    );
  }

  getInstantiatedBySubstationId(substationId: number): Observable<any> {
    return this.http.get(`${this.pathApi}getInstantiatedBySubstationId/${substationId}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  validateSchematic(dataIn: SchematicValidationDataIn): Observable<HttpResponse<ResponsePackage<SchematicValidationIssue[]>>> {
    return this.http.post<ResponsePackage<SchematicValidationIssue[]>>(`${this.pathApi}validateSchematic`, dataIn, {
      headers: this.headers,
      observe: 'response',
    });
  }
}
